import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import StudyFieldResults from './pages/study-field-results';
import AIChatInterface from './pages/ai-chat-interface';
import StudentDashboard from './pages/student-dashboard';
import StudentRegistration from './pages/student-registration';
import InteractiveQuizSystem from './pages/interactive-quiz-system';
import FieldExplorationHub from './pages/field-exploration-hub';
import SchoolDirectory from './pages/school-directory';
import ParentCounselorDashboard from './pages/parent-counselor-dashboard';
import AnalyticsDashboard from './pages/analytics-dashboard';
import StudentRegistrationFlow from './pages/student-registration-flow';
import ParentDashboardInterface from './pages/parent-dashboard-interface';
import RegistrationRoleSelection from './pages/registration-role-selection';
import ParentRegistration from './pages/parent-registration';
import CounselorRegistration from './pages/counselor-registration';
import CounselorManagementPortal from './pages/counselor-management-portal';
import UserLogin from './pages/user-login';
import ProfilePage from './pages/profile';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/registration-role-selection" element={<RegistrationRoleSelection />} />
        <Route path="/student-registration" element={<StudentRegistration />} />
        <Route path="/parent-registration" element={<ParentRegistration />} />
        <Route path="/counselor-registration" element={<CounselorRegistration />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/study-field-results" element={<StudyFieldResults />} />
        <Route path="/ai-chat-interface" element={<AIChatInterface />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
        <Route path="/student-registration-flow" element={<StudentRegistrationFlow />} />
        <Route path="/interactive-quiz-system" element={<InteractiveQuizSystem />} />
        <Route path="/field-exploration-hub" element={<FieldExplorationHub />} />
        <Route path="/school-directory" element={<SchoolDirectory />} />
        <Route path="/parent-counselor-dashboard" element={<ParentCounselorDashboard />} />
        <Route path="/parent-dashboard-interface" element={<ParentDashboardInterface />} />
        <Route path="/counselor-management-portal" element={<CounselorManagementPortal />} />
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
